var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var Insert_Form_DraftDocument = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation insert_form_draft($applicationID: uuid!, $data: jsonb!, $formName: String!) {\n  insert_form_drafts_one(\n    object: {applicationID: $applicationID, data: $data, formName: $formName}\n    on_conflict: {constraint: form_drafts_applicationID_formName_key, update_columns: [formName, data]}\n  ) {\n    id\n  }\n}\n    "], ["\n    mutation insert_form_draft($applicationID: uuid!, $data: jsonb!, $formName: String!) {\n  insert_form_drafts_one(\n    object: {applicationID: $applicationID, data: $data, formName: $formName}\n    on_conflict: {constraint: form_drafts_applicationID_formName_key, update_columns: [formName, data]}\n  ) {\n    id\n  }\n}\n    "])));
/**
 * __useInsert_Form_DraftMutation__
 *
 * To run a mutation, you first call `useInsert_Form_DraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Form_DraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertFormDraftMutation, { data, loading, error }] = useInsert_Form_DraftMutation({
 *   variables: {
 *      applicationID: // value for 'applicationID'
 *      data: // value for 'data'
 *      formName: // value for 'formName'
 *   },
 * });
 */
export function useInsert_Form_DraftMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(Insert_Form_DraftDocument, options);
}
export var Get_Form_DraftsDocument = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    query get_form_drafts($applicationID: uuid!, $formName: String!) {\n  form_drafts(\n    where: {applicationID: {_eq: $applicationID}, formName: {_eq: $formName}}\n  ) {\n    id\n    data\n  }\n}\n    "], ["\n    query get_form_drafts($applicationID: uuid!, $formName: String!) {\n  form_drafts(\n    where: {applicationID: {_eq: $applicationID}, formName: {_eq: $formName}}\n  ) {\n    id\n    data\n  }\n}\n    "])));
/**
 * __useGet_Form_DraftsQuery__
 *
 * To run a query within a React component, call `useGet_Form_DraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Form_DraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Form_DraftsQuery({
 *   variables: {
 *      applicationID: // value for 'applicationID'
 *      formName: // value for 'formName'
 *   },
 * });
 */
export function useGet_Form_DraftsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(Get_Form_DraftsDocument, options);
}
export function useGet_Form_DraftsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(Get_Form_DraftsDocument, options);
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2F2ZURyYWZ0UHJvdmlkZXIuZ3FsLmpzeCIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlNhdmVEcmFmdFByb3ZpZGVyLmdxbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBRUEsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBQ3JDLE9BQU8sS0FBSyxNQUFNLE1BQU0sZ0JBQWdCLENBQUM7QUFDekMsSUFBTSxjQUFjLEdBQUcsRUFBVyxDQUFDO0FBbUJuQyxNQUFNLENBQUMsSUFBTSx5QkFBeUIsR0FBRyxHQUFHLGlaQUFBLDhVQVN2QyxJQUFBLENBQUM7QUFHTjs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBa0JHO0FBQ0gsTUFBTSxVQUFVLDRCQUE0QixDQUFDLFdBQXVHO0lBQzVJLElBQU0sT0FBTyx5QkFBTyxjQUFjLEdBQUssV0FBVyxDQUFDLENBQUE7SUFDbkQsT0FBTyxNQUFNLENBQUMsV0FBVyxDQUFnRSx5QkFBeUIsRUFBRSxPQUFPLENBQUMsQ0FBQztBQUMvSCxDQUFDO0FBSVAsTUFBTSxDQUFDLElBQU0sdUJBQXVCLEdBQUcsR0FBRyxtUkFBQSxnTkFTckMsSUFBQSxDQUFDO0FBRU47Ozs7Ozs7Ozs7Ozs7Ozs7R0FnQkc7QUFDSCxNQUFNLFVBQVUsdUJBQXVCLENBQUMsV0FBeUY7SUFDekgsSUFBTSxPQUFPLHlCQUFPLGNBQWMsR0FBSyxXQUFXLENBQUMsQ0FBQTtJQUNuRCxPQUFPLE1BQU0sQ0FBQyxRQUFRLENBQXNELHVCQUF1QixFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQ2hILENBQUM7QUFDUCxNQUFNLFVBQVUsMkJBQTJCLENBQUMsV0FBOEY7SUFDaEksSUFBTSxPQUFPLHlCQUFPLGNBQWMsR0FBSyxXQUFXLENBQUMsQ0FBQTtJQUNuRCxPQUFPLE1BQU0sQ0FBQyxZQUFZLENBQXNELHVCQUF1QixFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQ3BILENBQUMifQ==